<template>
  <div>
    <div class="homeHead" :style="!$route.meta.isHeadBj ? '' : 'height:50px'">
      <div style="height: 45px; padding: 10px 20px" class="flexLR">
        <transition name="slide-right" mode="out-in">
          <div v-if="$route.meta.isHead" style="width: 80%">
            <van-icon
              name="arrow-left"
              @click="$router.go(-1)"
              size="22"
              color="#fff"
            />
          </div>
        </transition>
        <transition name="slide-right" mode="out-in">
          <div
            class="flexLR"
            :style="{ width: $route.meta.isHead ? '20%' : '100%' }"
          >
            <van-icon
              style="transform: rotate(90deg); margin-right: 20px"
              name="sort"
              size="22"
              color="#fff"
              role="20"
              @click="cutProjectShow = true"
            />
            <van-icon
              name="bell"
              :badge="publicityList.length"
              size="22"
              color="#fff"
              @click="
                $router.push({
                  name: 'message',
                  params: { list: publicityList },
                })
              "
            />
          </div>
        </transition>
      </div>
      <div v-if="$route.meta.isHeadBj ? false : true">
        <img
          :src="$store.state.pImg"
          style="
            margin: 0 auto;
            display: block;
            border-radius: 10px;
            width: 48px;
            height: 48px;
          "
          alt=""
        />
        <div class="flex" style="justify-content: center; margin-top: 10px">
          <van-icon name="label" color="#fff" size="16" />
          <div
            style="margin-left: 5px;
              font-weight: bold;
              color: #fff;
              font-size: 16px;
            "
          >
            {{ $store.state.pName }}
          </div>
        </div>
      </div>
    </div>
    <div
      :style="
        !$route.meta.isHeadBj
          ? 'position: relative;height:72%;'
          : 'position: relative;height:72%;'
      "
    >
      <div
        :style="`position:absolute;z-index:999;height:calc(100vh - 50px);margin-top:${
          ($route.meta.isHead || $route.meta.menu) &&
          ![
            'message',
            'Menus',
            'MenuInfo',
            'addMenu',
            'SecurityInfo',
            'addSecurity',
            'auditInfo',
            'UserMenus',
            'bdInfo',
            'UpdateMenuTemplate',
          ].includes($route.name)
            ? '-50px'
            : '0px'
        };width: 100%;overflow-y: scroll;`"
      >
        <transition name="slide-bottom" mode="out-in">
          <router-view
            ref="routerView"
            v-if="routerView"
            @updateLoading="updateLoadingFC"
          ></router-view>
        </transition>
      </div>

      <!-- <van-pull-refresh
        v-model="isLoading"
        pull-distance="10"
        @refresh="onRefresh"
        style="height:95%"
      > -->

      <!-- </van-pull-refresh> -->
    </div>
    <van-popup
      v-model="cutProjectShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-picker
        title="选择项目"
        show-toolbar
        :columns="projectList"
        value-key="proj07"
        :default-index="cutActive"
        @confirm="cutProjectConfirm"
        @cancel="cutProjectShow = false"
      />
    </van-popup>
    <van-popup
      v-model="messageShow"
      round
      :style="{ height: '80%', width: '80%' }"
    >
      <div style="padding: 20px">
        <div class="flex" style="justify-content: center">
          <van-icon name="bell" size="18" />
          <div style="font-weight: 500; font-size: 16px; text-align: center">
            消息
          </div>
        </div>
        <van-swipe-cell
          style="margin: 15px 0"
          v-for="(item, index) in publicityList"
          :key="index"
        >
          <div
            @click="
              $Dialog
                .alert({
                  title: item.shpy02,
                  message: item.shpy03,
                })
                .then(() => {
                  // on close
                })
            "
            style="height: 40px; line-height: 20px"
          >
            <div class="flexLR" style="height: 100%">
              <div
                class="flexLR"
                style="width: 90%; justify-content: left; height: 100%"
              >
                <img src="../../assets/mobileImg/项目通知.png" alt="" />
                <div
                  style="
                    height: 100%;
                    width: 100%;
                    align-items: flex-start;
                    margin-left: 10px;
                  "
                  class="flexcolumn"
                >
                  <div class="nowrap" style="width: 100%">
                    {{ item.shpy02 }}
                  </div>
                  <div style="color: #a2a2a2">
                    发布时间：2021-09-30 15:45:29
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template #right>
            <van-button
              size="small"
              style="height: 100%"
              square
              text="同意"
              type="info"
              class="delete-button"
            />
            <van-button
              size="small"
              style="height: 100%"
              square
              text="拒绝"
              type="warning"
              class="delete-button"
            />
            <!-- <van-button
              size="small"
              style="height:100%"
              square
              text="删除"
              type="danger"
              class="delete-button"
            /> -->
          </template>
        </van-swipe-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { GetMessage, GetMyIndex } from "@/api/index";
export default {
  name: "home",
  data() {
    return {
      transitionName: "slide-bottom",
      isLoading: false,
      routerView: true,
      menuList: [
        {
          title: "项目详情",
          icon: require("../../assets/mobileImg/项目详情.png"),
          path: "/Backlog",
          // path: "",
        },
        {
          title: "进度上报",
          icon: require("../../assets/mobileImg/进度上报.png"),
          path: "/Inform",
        },
        {
          title: "工程资料",
          icon: require("../../assets/mobileImg/工程资料.png"),
          path: "/Abnormal",
          // path: "",
        },
        {
          title: "实景上传",
          icon: require("../../assets/mobileImg/实景上传.png"),
          path: "/Opinion",
        },
        {
          title: "扫码上传",
          icon: require("../../assets/mobileImg/扫码上传.png"),
          path: "/Survey",
        },
        {
          title: "模型浏览",
          icon: require("../../assets/mobileImg/模型浏览.png"),
          path: "/Warehouse",
          // path: "",
        },
      ],
      publicityList: [],
      messageShow: false,
      cutProjectShow: false,
      projectList: [1, 2, 3, 4],
    };
  },
  computed: {
    cutActive() {
      let index;
      this.projectList.some((i, inx) => {
        if (i.proj01 == this.$store.state.pid) {
          index = inx;
        }
      });
      return index;
    },
  },
  created() {
    this.getData();
    this.getCutProject();
  },
  watch: {
    $route: {
      handler(to, from) {
        const tabPath = [
          "/home",
          "/discussion",
          "/schoolResource",
          "/My",
          "/discussion/joint",
        ];
        if (
          tabPath.some((item) => item == to.path) &&
          tabPath.some((item) => item == from.path)
        ) {
          this.transitionName = "fade";
        } else {
          const toDepth = to.path.split("/").length;
          const fromDepth = from.path.split("/").length;
          this.transitionName =
            toDepth < fromDepth ? "slide-right" : "slide-left";
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    async getCutProject() {
      let res = await GetMyIndex({
        params: {
          pid: this.$store.state.qid,
          uid: this.$store.state.uid,
          type: 1,
          secahword: "",
          manager: 2,
        },
      });
      this.projectList = res.Data;
    },
    updateLoadingFC(name) {
      this.isLoading = false;
    },
    cutProjectConfirm(v) {
      this.$store.state.PlanList = [];
      this.$store.state.pid = v.proj01;
      this.$store.state.pName = v.proj07;
      this.$store.state.pImg = this.$store.state.baseUrl + v.proj24;
      this.cutProjectShow = false;
      this.onRefresh();
    },
    onRefresh() {
      this.routerView = false;
      this.$nextTick(() => {
        this.routerView = true;
      });
      // try {
      //   this.$refs.routerView.updateData();
      // } catch (error) { }
    },
    menuBtn(item) {
      if (item.path == "") {
        this.$Toast.fail("此功能研发中...");
      } else {
        this.$router.push(item.path);
      }
    },
    async getData() {
      let res = await GetMessage();
      if (res.Code > 0) this.publicityList = res.Data;
    },
  },
};
</script>

<style lang="scss">
.homeHead {
  height: 28%;
  width: 100%;
  background-image: url("../../assets/mobileImg/375X160.png");
  background-repeat: no-repeat;
  background-size: cover;
}

/deep/body .van-toast {
  min-width: 100px !important;
}

.announcementItem {
  padding: 20px 0;
  border-bottom: 1px solid rgb(240, 240, 240);
}

.menuStyleTitle {
  font-size: 30px;
  padding: 20px 0;
  border-bottom: 1px solid rgb(240, 240, 240);
}

.menuItemStyle {
  width: 25%;
  padding: 4%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  background: #fff;
}

.menuStyle {
  background-color: #fff;
}

.index {
  width: 100%;
  background: #f5f5f5;

  .van-dialog__header {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
    margin: 0 auto;
  }

  .index_header {
    width: 100%;
    height: 486px;
    background: #14a8e9;
    padding-top: 76px;
    text-align: center;

    .project {
      width: 100%;
      height: 100px;
      font-size: 26px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .checkguan {
        border-bottom: 6px solid #fff;
      }

      .guan {
        width: 250px;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 36px;
          font-weight: 700;
        }

        img {
          width: 44px;
          height: 44px;
          vertical-align: sub;
        }
      }
    }

    img {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      border-radius: 45%;
    }

    p {
      height: 50px;
      line-height: 50px;
      font-size: 24px;
      color: #fff;
    }

    .user_name {
      font-size: 28px;
      font-weight: 700;
    }
  }

  .content {
    width: 100%;
    padding: 0 24px;

    .content_item {
      margin-top: 15px;
      height: 225px;
      border-radius: 10px;
      box-shadow: 0 0 10px #eee;
      background: #fff;
      padding: 15px;

      .img_style {
        position: relative;

        img {
          width: 200px;
          height: 200px;
          border-radius: 10px;
          float: left;
          margin-right: 35px;
        }

        .gl {
          background-color: #003565;
        }

        i {
          display: block;
          position: absolute;
          top: 0px;
          right: 35px;
          font-size: 12px;
          width: 80px;
          height: 40px;
          background-color: #e6a23c;
          text-align: center;
          border-radius: 0 3px 0 10px;
          color: #ffffff;
        }
      }

      div {
        float: left;

        p {
          color: #005073;
          font-size: 20px;

          span {
            font-weight: 700;
          }
        }
      }
    }
  }
}

.iconSpan {
  width: 55px;
  height: 55px;
  background-color: #fff;
  border-radius: 6px;
}

/deep/ .van-pull-refresh {
  height: 100%;
}
</style>
